/**
 * Helper form component for rendering checkboxes
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

// import components
import Base from "../BaseComponent.js.jsx";

class CheckboxInput extends Base {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: this.props.checked
    };
    this._bind('_handleInputChange');
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.value !== this.state.isChecked) {
      this.setState({isChecked: !this.state.isChecked})
    }
  }

  _handleInputChange(e) {
    const event = e;
    const checked = e.target.checked;
    const value = checked;
    const name = e.target.name;
    event.target = Object.assign({}, e.target, {
      checked: checked
      , name: name
      , value: checked
    });
    this.props.change(event);
  }

  render() {
    const {
      checked
      , disabled
      , helpText
      , label
      , name
      , tooltipText
      , value
    } = this.props;
    const tooltipId = Math.floor(Math.random()*16777215).toString(16);
    return (
      <div className="input-group">
        <input
          checked={value}
          disabled={disabled}
          name={name}
          onChange={this._handleInputChange}
          type="checkbox"
          value={value}
        />
        <label htmlFor={name}> {label}
        { tooltipText ?
          <div className="u-pullRight">
            <sup><i className="far fa-info-circle" data-tip data-for={tooltipId} /></sup>
            <ReactTooltip
              aria-haspopup='true'
              className="yt-tooltip"
              id={tooltipId}
              place="top"
              type="dark"
            >
              <p>{tooltipText}</p>
            </ReactTooltip>
          </div>
        :
          null
        }
        </label>
        { helpText ?
            <div>
              <small className="help-text"><em>{helpText}</em></small>
            </div>
          :
            null
        }
      </div>
    )
  }
}

CheckboxInput.propTypes = {
  change: PropTypes.func.isRequired
  , checked: PropTypes.bool
  , disabled: PropTypes.bool
  , helpText: PropTypes.any
  , label: PropTypes.string
  , name: PropTypes.string.isRequired
  , value: PropTypes.bool.isRequired
}

CheckboxInput.defaultProps = {
  checked: false
  , disabled: false
  , helpText: ''
  , label: ''
}

export default CheckboxInput;



// WEBPACK FOOTER //
// global/components/forms/CheckboxInput.js.jsx